import { useBrand } from "@/contexts/BrandContext";
import ClassicHome from "@/components/templates/ClassicHome";
import ElegantHome from "@/components/templates/ElegantHome";
import ModernHome from "@/components/templates/ModernHome";
import LandingHome from "@/components/templates/LandingHome";
import HeritageHome from "@/components/templates/HeritageHome";

export default function Index() {
  const { brand } = useBrand();

  switch (brand.template) {
    case "elegant":
      return <ElegantHome />;
    case "modern":
      return <ModernHome />;
    case "landing":
      return <LandingHome />;
    case "heritage":
      return <HeritageHome />;
    case "classic":
    default:
      return <ClassicHome />;
  }
}
